import styled from 'styled-components'

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ isFullPage }) => !isFullPage && 'padding-bottom: 70px;'}
`
